import React from 'react';
import {connect} from 'react-redux';
import {DashboardLayout} from '../../components';
import {verificationsIc} from '../../assets/images/images';

function VerificationWrapper({children, action}) {
  return (
    <DashboardLayout
      breadCrumbs={
        <p className="text-tiny font-normal text-deepBlue">Verifications</p>
      }
    >
      <div className="flex items-center justify-between gap-6 mt-6 mb-6 md:gap-0 sm:mt-0">
        {action}
      </div>

      {children}
    </DashboardLayout>
  );
}

export default connect(state => state, null)(VerificationWrapper);
